(function() {
    'use strict';
    angular
        .module('serviciosocialApp')
        .factory('SSAmbito', SSAmbito);

    SSAmbito.$inject = ['$resource', 'DateUtils'];

    function SSAmbito ($resource, DateUtils) {
        var resourceUrl =  'api/s-s-ambitos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
